import { api } from './client';

/*  Specchio dei contratti dei predefiniti del preventivo.

    Due permessi, come per i testi d'offerta e per la stessa ragione: leggere serve a chi
    compila per capire da dove viene il ricarico che si trova addosso, scrivere no —
    quei numeri spostano il margine di tutte le offerte che verranno.
*/

export interface PredefinitiLetti {
  /** Il codice di Mago, o la stringa vuota per la riga «tutti gli altri». */
  codiceCategoria: string;
  /** Come si legge: «Condomini», oppure «Tutti gli altri» per la riga generale. */
  categoria: string;
  ricaricoPercentuale: number;
  costiGeneraliPercentuale: number;
  giorniValidita: number;
  /** Falso quando i valori sono ereditati: nessuno li ha scelti per questa categoria. */
  propri: boolean;
}

export interface PredefinitiDaScrivere {
  ricaricoPercentuale: number;
  costiGeneraliPercentuale: number;
  giorniValidita: number;
}

/*  I VALORI UGUALI PER TUTTI I CLIENTI.

    Separati da `PredefinitiLetti` perché rispondono a un'altra domanda: quelli sono
    taratura commerciale e cambiano per categoria, questi sono fatti dell'azienda —
    quanto costa una cena, quanto vale un chilometro — e per categoria non cambiano.

    Fino al 01/10/2026 stavano in `appsettings.json`, cioè li cambiava chi installa.
*/
export interface ParametriLetti {
  tariffaManodoperaOraria: number;
  tariffaKm: number;
  indennitaTrasfertaGiornaliera: number;
  /** Distanza dalla sede, SOLA ANDATA, oltre la quale si pranza fuori. */
  kmPerIlPranzo: number;
  /** Distanza dalla sede, SOLA ANDATA, oltre la quale si dorme fuori. */
  kmPerIlPernotto: number;
  costoPranzo: number;
  costoCena: number;
  costoPernottamento: number;
  /** La percentuale con cui nasce la voce degli oneri. Zero: non nasce. */
  percentualeSicurezza: number;
  /** Le ore che fanno una giornata di cantiere: da qui escono giorni e viaggi. */
  orePerGiornata: number;
  /** Come si chiama in offerta quello che non si fa vedere riga per riga. */
  voceMaterialiNascosti: string;
}

export interface ParametriDaScrivere {
  tariffaManodoperaOraria: number;
  tariffaKm: number;
  indennitaTrasfertaGiornaliera: number;
  kmPerIlPranzo: number;
  kmPerIlPernotto: number;
  costoPranzo: number;
  costoCena: number;
  costoPernottamento: number;
  percentualeSicurezza: number;
  orePerGiornata: number;
  voceMaterialiNascosti: string | null;
}

export const predefiniti = {
  elenco: () => api.get<PredefinitiLetti[]>('/predefiniti-preventivo'),

  parametri: () => api.get<ParametriLetti>('/predefiniti-preventivo/parametri'),

  impostaParametri: (valori: ParametriDaScrivere) =>
    api.put<ParametriLetti>('/predefiniti-preventivo/parametri', valori),

  /*  Il codice vuoto è «tutti gli altri» e ha una rotta sua, `/generale`: una rotta con
      un segmento vuoto non esiste, e lasciar decidere al server che «percorso mancante»
      vuol dire «tutti» sarebbe il modo di scrivere sulla riga generale per sbaglio.  */
  imposta: (codiceCategoria: string, valori: PredefinitiDaScrivere) =>
    api.put<PredefinitiLetti>(
      `/predefiniti-preventivo/${codiceCategoria === '' ? 'generale' : encodeURIComponent(codiceCategoria)}`,
      valori,
    ),

  /*  La categoria torna a ereditare da «tutti gli altri»: non cancella niente di già
      scritto, perché i preventivi nati hanno i loro numeri sopra e non li rileggono mai
      più da qui. Non si guarda la risposta — dopo una scrittura la schermata rilegge
      tutto, perché toccare «tutti gli altri» cambia anche le righe che ereditano.  */
  rimuovi: (codiceCategoria: string) =>
    api.elimina(`/predefiniti-preventivo/${encodeURIComponent(codiceCategoria)}`),
};
